export default __webpack_public_path__ + "static/media/pic39.207de804.jpg";